import(/* webpackMode: "eager" */ "/workspace/src/app/[locale]/customisation/page.tsx");
